export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5559.667d4fc4.jpg";